module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "right-inner"
  }, [_vm._m(0), _vm._v(" "), _c('education'), _vm._v(" "), _c('projects'), _vm._v(" "), _c('playground'), _vm._v(" "), _c('experience'), _vm._v(" "), _c('additional'), _vm._v(" "), _c('social')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction"
  }, [_c('h3', [_vm._v("Introduction")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Namaste! 🙏 My name is Animesh Manglik and I develop for Web and Mobile ")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Welcome to the TL;DR version of my website which I am currently redesigning. This has been a fun experiment, make sure you interact with the phone on the left")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Hope you have a great day!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464be383","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Right.vue
// module id = 57
// module chunks = 0